







































import IEventBrandingDto from "@/chipply/IEventBrandingDto";
import { StorePriceDisplayType, WebHelper } from "chipply-common";
import Vue from "vue";
import Component from "vue-class-component";
import "@mdi/font/css/materialdesignicons.css";
import { Prop, Provide, Watch } from "vue-property-decorator";
import { Utils } from "chipply-common";
import StoreFooter from "./layout/StoreFooter.vue";
import { StoreHelper } from "@/chipply/helper/StoreHelper";
import IEventCategoriesDto from "@/chipply/i-event-categories-dto";
import StoreAppBar from "./layout/StoreAppBar.vue";
import IEventCategoryDto from "@/chipply/i-event-category-dto";
import { DealerLogoDisplay } from "chipply-common";
import CategoryDesktopPanel from "./layout/CategoryDesktopPanel.vue";
import IPriceDisplay from "@/chipply/interface/IPriceDisplay";

@Component({
    components: { StoreFooter, StoreAppBar, CategoryDesktopPanel },
    computed: {
        mobile() {
            return this.$vuetify.breakpoint.smAndDown;
        },
    },
})
export default class StoreLayout extends Vue {
    @Prop({
        type: Number,
    })
    public eventId!: number | null;

    @Prop({
        type: Object,
    })
    public branding!: IEventBrandingDto | null;

    @Prop({
        type: Boolean,
    })
    public checkout!: boolean | null;

    @Prop({
        type: Boolean,
    })
    public hideTag!: boolean;

    @Prop({
        type: Number,
    })
    public totalDue!: number | null;

    @Prop({
        type: Boolean,
        default: false,
    })
    public showCategory!: boolean;

    @Provide()
    public get priceDisplay(): IPriceDisplay {
        return this.sourcePriceDisplay;
    }

    private sourcePriceDisplay: IPriceDisplay = {
        displayType: StorePriceDisplayType.Dollars,
        dollarValuePerPoint: 0,
    };

    public cartQuantity: number | null = null;
    public drawer = false;
    public isNavigationButtonVisible = false;
    public Utils = Utils;

    public categories: IEventCategoriesDto | null = null;
    private selectedCategory: IEventCategoryDto | null = null;
    private storeHelper = new StoreHelper();
    private showCatNav = false;
    public DealerLogoDisplay = DealerLogoDisplay;

    @Watch("eventId")
    public async onEventIdChanged() {
        if (this.eventId! > 0) {
            await this.get(this.eventId!);
        }
    }

    @Watch("branding.dealerId")
    @Watch("eventId")
    public async onBrandingChanged() {
        if (this.branding && this.branding.dealerId > 0 && this.eventId! > 0) {
            await this.getCategories();
            this.updatePriceDisplay();
        }
    }

    private updatePriceDisplay() {
        // Modify properties of the existing object instead of replacing the entire object
        this.sourcePriceDisplay.displayType = this.branding?.storePriceDisplayType || StorePriceDisplayType.Dollars;
        this.sourcePriceDisplay.dollarValuePerPoint = this.branding?.storeDollarValuePerPoint || 0;
    }

    public async created() {
        //the watch wasn't firing during testing so I'm doing this
        if (this.eventId! > 0) {
            await this.get(this.eventId!);
        }

        await this.onBrandingChanged();
    }

    public goToStore() {
        location.assign(`/store.aspx?eid=${this.eventId}`);
    }

    public async openDrawer() {
        this.$emit("open");
    }

    public async get(eventId: number): Promise<void> {
        let baseUrl = "/api/Event/Cart?eventId=";
        baseUrl += encodeURIComponent(eventId);
        const results = (await WebHelper.getJsonData(baseUrl)) as {
            itemQuantity: number;
        };
        if (results) {
            this.cartQuantity = results.itemQuantity;
        } else {
            this.cartQuantity = 0;
        }
    }

    public async getCategories() {
        const categories = await this.storeHelper.getCategories(this.branding!.dealerId, this.eventId!, true);
        this.categories = categories;
    }

    private get logoLessNav() {
        if (this.branding && this.branding.dealerLogoDisplay === DealerLogoDisplay.UseLogo) {
            return "185px";
        } else if (this.branding && this.branding.dealerLogoDisplay === DealerLogoDisplay.NoLogoUseText) {
            return "175px";
        } else {
            return "100px";
        }
    }

    private blurNav() {
        this.toggleCatNav();
    }

    private toggleCatNav() {
        if (this.showCatNav == true) {
            this.showCatNav = false;
        } else {
            this.showCatNav = true;
        }
    }

    public viewAll() {
        location.assign("./store.aspx?eid=" + this.eventId + "&action=viewall");
    }

    private async selectCat(category: IEventCategoryDto) {
        this.selectedCategory = category;
        if (
            (category.containers && category.containers.length == 0) ||
            category.isPackage ||
            this.storeHelper.checkPasswords(category).length == 0 ||
            (category.hasPassword && !category.isAuthorized)
        ) {
            location.assign("./store.aspx?eid=" + this.eventId + "&acid=" + category.eventCategoryID);
        }
    }
}
